module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp1_7005.85fd94e4.png";